import Vue from 'vue';
import _ from 'lodash';
import axios from 'axios';

 // Live Search


new Vue({
  el: '#liveserachapp',
  data: {
    question: '',
    lang: '',
    answer: '',
    loader: false,
    result: '',
    url: '/wp-json/search_endpoint/v1/livesearch',

  },
  mounted() {
    this.lang = this.$refs.lang.dataset.value;
  },
  watch: {
    // whenever question changes, this function will run
    question: function (newQuestion) {
      this.loader = true;
      this.getResult()

      if(this.question == ''){
        this.result = ''
      }
    }
  },
  methods: {
    getResult: _.debounce(
      function () {
        if (this.question) {
          var vm = this
					var searchUrl = this.url + '?&s=' + this.question + '&lang=' + this.lang
          axios.get(searchUrl)
            .then(function (response) {
              vm.result = response.data.sort((a, b) => {
                if (a.post_type === b.post_type) {
                  return a.post_title < b.post_title ? -1 : 1;
                }

                if (a.post_type === 'page') {
                  return -1;
                } else if (a.post_type == 'product' && b.post_type !== 'page') {
                  return -1;
                }

                return 1;
              })
              vm.answer =  vm.question + ' (' + response.data.length + ')'
              vm.loader = false;

            })
            .catch(function (error) {
              vm.answer = error
            })
        } else {
          this.answer = ''
          this.loader = false;
        }
      },
      // This is the number of milliseconds we wait for the user to stop typing.
      500
    ),
    cancel: function () {
      // let's make the field empty
      this.loader = false;
      this.question = ''
      this.result = ''
    }
  }
})
